const forms = [
    {
        name: "form-request",
        url: "/ajax/form_submit.php",
        localUrl: "http://www.mocky.io/v2/596a5f03110000920701cd92"
    },
    {
        name: "form-subscribe",
        url: "/ajax/subscribe.php",
        localUrl: "http://www.mocky.io/v2/596a5f03110000920701cd92"
    },
    {
        name: "catalog-filter",
        //url: "/ajax/subscribe.php",
        localUrl: "http://www.mocky.io/v2/596a5f03110000920701cd92"
    },
]

export default forms;